import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/trainings/list';
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const {
      page = 0,
      rowsPerPage = 20,
      sortColumn = 'created_at',
      sortDirection = 'desc',
      modelId,
      // Multi-value filters used by the workspace-wide Trainings page.
      // Each is an array of UIDs/values; we serialize as
      // comma-separated query params and the backend parses them
      // back via _parse_csv. Empty arrays / undefined skip the
      // param entirely.
      modelIds,
      segmentIds,
      statuses,
    } = action.payload;

    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('per_page', String(rowsPerPage));
    params.set('sort_column', sortColumn);
    params.set('sort_direction', sortDirection);

    if (modelId) params.set('model_id', modelId);

    const csv = (arr) => Array.isArray(arr) && arr.length > 0 ? arr.join(',') : null;
    const modelIdsCsv = csv(modelIds);
    const segmentIdsCsv = csv(segmentIds);
    const statusesCsv = csv(statuses);
    if (modelIdsCsv) params.set('model_ids', modelIdsCsv);
    if (segmentIdsCsv) params.set('segment_ids', segmentIdsCsv);
    if (statusesCsv) params.set('statuses', statusesCsv);

    const url = `${config.API_URL}/training?${params.toString()}`;

    const response = yield call(
      axios.get,
      url,
      { headers: getLocalUser() }
    );
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}